import React from 'react';

export const BoothShowcase = () => (
  <section id="booth" className="py-24 bg-[#8B7355] text-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute inset-0" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\\"60\\" height=\\"60\\" viewBox=\\"0 0 60 60\\" xmlns=\\"http://www.w3.org/2000/svg\\"%3E%3Cg fill=\\"none\\" fill-rule=\\"evenodd\\"%3E%3Cg fill=\\"%23ffffff\\" fill-opacity=\\"0.4\\"%3E%3Cpath d=\\"M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\\"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
      }}></div>
    </div>

    <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
      <h2 className="text-5xl md:text-6xl font-serif mb-6 italic">The Showpiece</h2>
      <p className="text-xl mb-12 max-w-3xl mx-auto opacity-90">
        Behold a vintage-style masterpiece that will steal the show at your event
      </p>

      <div className="grid md:grid-cols-3 gap-8 mb-12">
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg">
          <h3 className="text-2xl font-serif mb-4 text-[#C9A961]">Handcrafted Details</h3>
          <p className="opacity-90">Brass fittings, rich wood panels, and ornate metalwork—every element tells a story</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg">
          <h3 className="text-2xl font-serif mb-4 text-[#C9A961]">Velvet Framed Camera</h3>
          <p className="opacity-90">Luxurious red velvet curtains frame the camera lens for that perfect vintage shot</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg">
          <h3 className="text-2xl font-serif mb-4 text-[#C9A961]">Vintage on Wheels</h3>
          <p className="opacity-90">Beautifully mobile—this rolling masterpiece brings timeless elegance anywhere</p>
        </div>
      </div>

      <div className="relative max-w-4xl mx-auto mt-12">
        <img
          src="/booth2.jpg"
          alt="The Vintage Booth - Angled View"
          className="w-full rounded-lg shadow-2xl"
        />
      </div>
    </div>
  </section>
);
